export default {
  hasError: (state) => state.hasError,
  errorMessage: (state) => state.errorMessage,
  errorSubMessage: (state) => state.errorSubMessage,
  errorDetails: (state) => state.errorDetails,
  visibleTerminal: (state) => state.visibleTerminal,
  leaveToRoute: (state) => state.leaveToRoute,
}
